// extracted by mini-css-extract-plugin
export var currencyInput = "_jr-1";
export var currencySymbol = "_jr-0";